import { useDispatch } from 'react-redux';

import { clearAuthCookies, userSignout } from '../../../../actions/hub/hubAuthPagesActions';
import clearLocalStorage from '../../../../util/clearLocalStorage';

const useSignout = () => {
  const dispatch = useDispatch();
  const signout = ({ hardSignout = false }: { hardSignout?: boolean } = {}) => {
    clearLocalStorage();
    clearAuthCookies();
    if (hardSignout) {
      dispatch(userSignout());
    }
  };

  return signout;
};

export default useSignout;
